const userStatusEnum = {
    REGISTERING: 0,
    REGISTERED: 1,
    BLOCKED: 2,
    BANNED: 3,
    RETIRED: 4,
    REMEMBERED: 5
}    

const userRoleEnum = {
    GUEST: 0,
    MEMBER: 1,
    VIP: 2,
    EDITOR: 3,
    MODERATOR: 4,
    FORUM_ADMINISRTATOR: 5,
    CORE_ADMINISRTATOR: 6
}

const settingKeys = {
    DATE_FORMAT: 1,
    TIME_FORMAT: 2,
    POST_FORMAT: 4,
    POST_ORDER: 5,
    POSTS_PER_PAGE: 6,
    TOPICS_PER_PAGE: 7,
    USE_MESSAGING: 8,
    USE_EMOTICONS: 9,
    VIEW_SIGNATURES: 10,
    VIEW_AVATARS: 11,
    THEME: 12,
    FONT_SIZE: 13,
    FONT_COLOR: 14,
    FONT_WEIGHT: 15,
    AUTO_SUBSCRIBE_TOPIC_REPLY_SITE_NOTIFICATION: 16,
    AUTO_SUBSCRIBE_TOPIC_REPLY_EMAIL: 17,
    AUTO_SUBSCRIBE_TOPIC_CREATE_SITE_NOTIFICATION: 18,
    AUTO_SUBSCRIBE_TOPIC_CREATE_EMAIL: 19,
    CODE_FONT_SIZE: 20,
    USE_CKEDITOR: 21,
}

function createDefaultUser() {

    var model = {
        id: null,
        displayName: null,
        status: userStatusEnum.REGISTERING,
        roles: [userRoleEnum.GUEST],
        settings: [
            { settingID: 1, settingName: '', settingValue: 'YYYY/MM/DD'},
            { settingID: 2, settingName: '', settingValue: 'hh:mm a'},
            { settingID: 4, settingName: '', settingValue: 'bbcode'},
            { settingID: 5, settingName: '', settingValue: 'asc'},
            { settingID: 6, settingName: '', settingValue: '20'},
            { settingID: 7, settingName: '', settingValue: '20'},
            { settingID: 8, settingName: '', settingValue: 'true'},
            { settingID: 9, settingName: '', settingValue: 'true'},
            { settingID: 10, settingName: '', settingValue: 'true'},
            { settingID: 11, settingName: '', settingValue: 'true'},
            { settingID: 12, settingName: '', settingValue: 'light'},
            { settingID: 13, settingName: '', settingValue: 'default'},
            { settingID: 14, settingName: '', settingValue: 'default'},
            { settingID: 15, settingName: '', settingValue: 'default'},
            { settingID: 16, settingName: '', settingValue: 'true'},
            { settingID: 17, settingName: '', settingValue: 'false'},
            { settingID: 18, settingName: '', settingValue: 'true'},
            { settingID: 19, settingName: '', settingValue: 'false'},
            { settingID: 20, settingName: '', settingValue: 'default'},
            { settingID: 21, settingName: '', settingValue: 'false'},
        ],
        getSetting: function(key) {
            let settings = this.settings;
            if (key === settingKeys.DATE_FORMAT) return settings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.TIME_FORMAT) return settings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.POST_ORDER) return settings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.POSTS_PER_PAGE) return parseInt(settings.find(x => x.settingID === key).settingValue);
            if (key === settingKeys.POST_FORMAT) return settings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.TOPICS_PER_PAGE) return parseInt(settings.find(x => x.settingID === key).settingValue);
            if (key === settingKeys.USE_EMOTICONS) return settings.find(x => x.settingID === key).settingValue === 'true';
            if (key === settingKeys.USE_MESSAGING) return settings.find(x => x.settingID === key).settingValue === 'true';
            if (key === settingKeys.VIEW_AVATARS) return settings.find(x => x.settingID === key).settingValue === 'true';
            if (key === settingKeys.VIEW_SIGNATURES) return settings.find(x => x.settingID === key).settingValue === 'true';
            if (key === settingKeys.THEME) return settings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.FONT_SIZE) return settings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.FONT_COLOR) return settings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.FONT_WEIGHT) return settings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.AUTO_SUBSCRIBE_TOPIC_REPLY_SITE_NOTIFICATION) return settings.find(x => x.settingID === key).settingValue === 'true';
            if (key === settingKeys.AUTO_SUBSCRIBE_TOPIC_REPLY_EMAIL) return settings.find(x => x.settingID === key).settingValue === 'true';
            if (key === settingKeys.AUTO_SUBSCRIBE_TOPIC_CREATE_SITE_NOTIFICATION) return settings.find(x => x.settingID === key).settingValue === 'true';
            if (key === settingKeys.AUTO_SUBSCRIBE_TOPIC_CREATE_EMAIL) return settings.find(x => x.settingID === key).settingValue === 'true';
            if (key === settingKeys.CODE_FONT_SIZE) return settings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.USE_CKEDITOR) return settings.find(x => x.settingID === key).settingValue === 'true';
            return null;
        },
        isGuest: () => { return model.roles.includes(userRoleEnum.GUEST) },
        isMember: () => { return model.roles.includes(userRoleEnum.MEMBER) },
        isVIP: () => { return model.roles.includes(userRoleEnum.VIP) },
        isEditor: () => { return model.roles.includes(userRoleEnum.EDITOR) },
        isModerator: () => { return model.roles.includes(userRoleEnum.MODERATOR) },
        isForumAdmin: () => { return model.roles.includes(userRoleEnum.FORUM_ADMINISRTATOR) },
        isCoreAdmin: () => { return model.roles.includes(userRoleEnum.CORE_ADMINISRTATOR) },
        isMemberOf: (role) => {
            return model.roles.includes(role);
        }
    }

    return model
}

export default {
    defaultUser: createDefaultUser,
    statusEnum: userStatusEnum,
    roleEnum: userRoleEnum,
    settingKeys: settingKeys
};